import React, { useContext } from 'react';
import { ConfiguratorContext } from '../../context/ConfiguratorProvider';

import * as styles from './filterButton.module.scss';

const FilterButton = ({
  className,
  customClass,
  text,
  name,
  onClick,
  disabled,
}) => {
  const { isDev } = useContext(ConfiguratorContext);

  return (
    <>
      {isDev && <pre>FilterButton</pre>}
      <button
        className={`${styles.btn} ${styles[className]} ${styles[customClass]}`}
        name={name}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
        {customClass === 'tagSelected' && (
          <span className={styles.filterTagIcon}>
            <i className="material-icons">close</i>
          </span>
        )}
      </button>
    </>
  );
};

export default FilterButton;
